import "./PollDetailsComponent.scss";

import { Image } from "@fluentui/react-northstar";
import { AC, QuestionResultsCondensedCard } from "@teams/cards";
import {
  Question,
  QuestionType,
  TeamsAnonymityLevel,
  TeamsApplicationTypes,
  TeamsSurveyResponse,
} from "@teams/types";
import { IntegrationAutoLinkDTO, SurveyDTO } from "@teams/types/api";
import moment from "moment";
import React from "react";

import { useUserInfo } from "../../../../_shared/actions/useUserInfo";
import AgilePendingImage from "../../../../_shared/assets/agile-pending-image.svg";
import CorePendingImage from "../../../../_shared/assets/core-pending-image.svg";
import { HeroUnit, coreHeroUnitStyles } from "../../../../_shared/components/HeroUnit";
import { useTheme } from "../../../../_shared/state/ThemeProvider";
import {
  getFreeUserResultsUnavailableText,
  isSurveyResultsRestrictedForUser,
} from "../../../../_shared/utils/userHelpers";

type Props = {
  survey: SurveyDTO;
};

export const PollDetailsComponent: React.FC<Props> = ({ survey }) => {
  const { themeName, hostConfig } = useTheme();
  const { user } = useUserInfo();
  const className = `pollDetails pollDetails--theme-${themeName}`;

  const PendingImage = survey.applicationType === "msteams" ? CorePendingImage : AgilePendingImage;
  if (survey.state === "pending") {
    return (
      <div className={className}>
        <HeroUnit style={coreHeroUnitStyles}>
          <div className="pollDetails__pending-container">
            <p className="pollDetails__pending-container__text">
              Sending {moment(survey.deliverAt).format("MMMM Do [at] hh:mmA")}
            </p>
            <Image src={PendingImage} alt="Polly Pending" />
          </div>
        </HeroUnit>
      </div>
    );
  }

  const question = survey.questions[0];

  const pollDetailsHtml = renderSurveyResults(
    hostConfig,
    question,
    survey.responses || [],
    survey.autolinkIntegrations,
    survey.anonymity,
    survey.applicationType,
    isSurveyResultsRestrictedForUser(user, survey)
      ? `**${getFreeUserResultsUnavailableText(user)}**`
      : undefined
  );

  return <div className={className} dangerouslySetInnerHTML={{ __html: pollDetailsHtml }}></div>;
};

const renderSurveyResults = (
  hostConfig: AC.HostConfig,
  question: Question<QuestionType>,
  responses: TeamsSurveyResponse[],
  autolinkIntegrations: IntegrationAutoLinkDTO[] | undefined,
  surveyAnonymityLevel: TeamsAnonymityLevel,
  applicationType: TeamsApplicationTypes,
  altNoResponsesText?: string
) => {
  const card = QuestionResultsCondensedCard(
    question,
    responses,
    surveyAnonymityLevel,
    applicationType,
    autolinkIntegrations,
    5,
    {
      style: "emphasis",
    },
    true,
    true,
    undefined,
    undefined,
    altNoResponsesText
  );
  card.hostConfig = hostConfig;

  const result = card.render() as HTMLElement;
  result.style.padding = "0";

  return result.outerHTML;
};
